import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'
import i18n from 'modules/core/lib/i18n'
import { redirect } from 'react-router-dom'

const RootPage = lazy(() => import('modules/ai/pages/Settings/RootPage'))
const CreditsPage = lazy(() =>
  import('modules/ai/pages/Settings/CreditsPage').then((m) => ({ default: m.CreditsPage }))
)
const UsagePage = lazy(() =>
  import('modules/ai/pages/Settings/UsagePage').then((m) => ({ default: m.UsagePage }))
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.ai.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'one'),
      },
      children: [
        {
          index: true,
          loader: () => redirect(navigation.settings.ai.credits.path),
        },
        {
          path: navigation.settings.ai.credits.path,
          element: <CreditsPage />,
          handle: {
            meta: () => {
              return {
                title: i18n.t('ai.settings.tabs.credits'),
              }
            },
          },
        },
        {
          path: navigation.settings.ai.usage.path,
          element: <UsagePage />,
          handle: {
            meta: () => {
              return {
                title: i18n.t('ai.settings.tabs.usage'),
              }
            },
          },
        },
      ],
    },
  ]
}

export default settingsRoutes
